import React, { useEffect, useState } from 'react';
import { Modal, message } from 'antd';
import { reportProduct } from '../../../services/product';
import { isAuthenticated } from '../../../services/auth';

const ReportProduct = ({ product, productId, productReports, setReported }) => {
  const { user } = isAuthenticated();
  const [showModal, setShowModal] = useState(false);
  const [report, setReport] = useState({
    reason: '',
    details: '',
    product: productId,
    author: user._id,
  });

  const { reason, details } = report;

  const handleModal = () => {
    setShowModal(true);
  };

  const handleReport = async () => {
    if (reason === '') {
      return message.error('Selecione um motivo para esta denúncia');
    }
    const res = await reportProduct(productId, report);
    setShowModal(false);
    setReported(true);
    message.success(`Você denunciou ${product.name}`);
  };

  const handleCancel = () => {
    setShowModal(false);
  };
  const handleReason = (e) => {
    setReport({ ...report, reason: e.target.value });
  };
  const handleDetails = (e) => {
    setReport({ ...report, details: e.target.value });
  };

  return (
    <div>
      <div className='card rounded-0 profile-card mt-3 p-3'>
        <button
          className={
            productReports.includes(user._id)
              ? 'btn btn-danger form-control disabled rounded-0'
              : 'btn btn-danger form-control rounded-0'
          }
          onClick={handleModal}
        >
          <i className='far fa-flag'></i>{' '}
          {productReports.includes(user._id) ? (
            <>Você já denunciou este produto</>
          ) : (
            <>Denunciar este produto</>
          )}
        </button>
      </div>

      <Modal
        title={`Denunciar - '${product.name}'`}
        visible={showModal}
        onOk={handleReport}
        onCancel={handleCancel}
        okText='Denunciar'
        closable={false}
      >
        <select
          className='form-select rounded-0 shadow-none mb-1'
          aria-label='Selecione o motivo'
          onChange={handleReason}
        >
          <option selected disabled>
            Selecione o motivo
          </option>
          <option value='Produto é ilegal'>Produto é ilegal</option>
          <option value='Produto é spam'>Produto é spam</option>
          <option value='Categoria incorreta'>Categoria incorreta</option>
          <option value='Vendedor pediu pré-pagamento'>
            Vendedor pediu pré-pagamento
          </option>
          <option value='Produto já foi vendido'>
            Produto já foi vendido
          </option>
          <option value='Vendedor não responde'>Vendedor não responde</option>
          <option value='Outro'>Outro</option>
        </select>

        <textarea
          onChange={handleDetails}
          className='form-control rounded-0 shadow-none'
          rows='4'
          placeholder='Mais detalhes sobre esta denúncia'
        ></textarea>
      </Modal>
    </div>
  );
};

export default ReportProduct;
